import { useContext, useState } from 'react';
import { UserContext } from "../../context/user-context";
import FormInput from '../../components/form-input';
import Button from '../../components/button';
import { createLog, updateUserDocument } from '../../utils/firebase';
import {useNavigate} from 'react-router-dom';
import FormSelect from '../../components/form-select';

const LearningDevelopment = () => {
    const { currentUser } = useContext(UserContext);
    const [formFields, setFormFields] = useState({learning: currentUser["data"]["learning"] ? currentUser["data"]["learning"] : []});
    const navigate = useNavigate();
    const { learning } = formFields;

    const handleChange = (index, event) => {
        const { id, value } = event.target;
        learning[index][id] = value;

        setFormFields({...formFields});
    }

    const handleOnAdd = () => {
        learning.push({
            "from" : "",
            "to" : "",
            "title": "",
            "hours": "",
            "type": "Select",
            "sponsor": "",
        });

        setFormFields({...formFields});
    }

    const handleOnRemove = (index) => {
        learning.splice(index, 1);

        setFormFields({...formFields});
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const response = await updateUserDocument(currentUser["uid"], formFields);
        if (response === "success") {
            const log = {"action": "User updated PDS learning development", "by" : currentUser.uid}
            await createLog(log);

            Object.assign(currentUser["data"], formFields);
        }
        alert(response);
    }

    return (
        <div className='column'>
            <div className='columns main'>
                <div className='column is-8 is-offset-2'>
                    <h2 className='is-size-2 has-text-weight-bold my-6'>Learning & Development</h2>
                    <form onSubmit={handleSubmit}>
                        {learning.map((item, index) => {
                            return (
                                <div className='block' key={index}>
                                    <div className='columns is-vcentered'>
                                        <FormInput type="text" required id="title" value={item["title"]} onChange={(e) => handleChange(index, e)} label="Title of Learning & Development Interventions/Training Programs" additionalClasses="column is-10"/>
                                        <div className='column is-1' style={{marginTop: "22px"}}><button type='button' onClick={() => handleOnRemove(index)} className="delete is-large"></button></div>
                                    </div>
                                    
                                    <div className='columns'>
                                        <FormInput type="date" required id="from" value={item["from"]} onChange={(e) => handleChange(index, e)} label="From" additionalClasses="column is-5"/>
                                        <FormInput type="date" required id="to" value={item["to"]} onChange={(e) => handleChange(index, e)} label="To" additionalClasses="column is-5"/>
                                    </div>
                                    <div className='columns'>
                                        <FormInput type="number" id="hours" value={item["hours"]} onChange={(e) => handleChange(index, e)} label="No. of Hours" additionalClasses="column is-5"/>
                                        <FormSelect options={["Managerial", "Supervisory", "Technical", "Others"]} type="text" required id="type" onChange={(e) => handleChange(index, e)} value={item["type"]} label="Type of LD" additionalClasses="column is-5"/>
                                     </div>
                                    
                                    <div className='columns'>
                                        <FormInput type="text" id="sponsor" value={item["sponsor"]} onChange={(e) => handleChange(index, e)} label="Conducted/Sponsored by" additionalClasses="column is-10"/>
                                    </div>
                                </div>
                            )
                        })}
                        <Button additionalClasses="block mr-4" type="button" onClick={handleOnAdd}>Add Learning & Development</Button>
                        <Button additionalClasses="block is-success" type="submit">Submit</Button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default LearningDevelopment;